import { Suspense, lazy } from 'react';
import { Hearts } from 'react-loader-spinner'
import { Route, Routes, Navigate } from 'react-router-dom';

import { ShopProvider } from './Context/ShopContext';
// import { useLogin } from './Context/LoginContext';
// import { SubscriptionStatusProvider } from './Context/SubscriptionStatusContext';
import SubscriptionProtectedRoutes from './SubscriptionProtectedRoutes';
import SubscriptionGuestRoutes from './SubscriptionGuestRoutes';
// import { useSubscriptionStatus } from './Context/SubscriptionStatusContext';
const PurchaseConfirm = lazy(() => import(/* webpackChunkName: 'Checkout' */ './components/Item/PurchaseConfirm'));
const Item = lazy(() => import(/* webpackChunkName: 'Checkout' */ './components/Item/Item'));

const GiftSubscription = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/Subscription/GiftSubscription'));
//const BuyerProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/BuyerProducts'));
const Shop = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/ShopLanding'));
const SellerProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/SellerProducts'));
const SellerProfile = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/SellerProfile'));
const Notifications = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/Notifications/Notifications'));
const SellerReviews = lazy(() => import(/* webpackChunkName: 'Shop' */'./components/Buyer/SellerReviews'));
const ProtectedRoute = lazy(() => import(/* webpackChunkName: 'Shop' */ './ProtectedRoute'));

const BuyerProfile = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/Profile'));
const SendConfirmation = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/Confirmation/ShipConfirmation'));
const SAConfirmation = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/Confirmation/SAConfirmation'));
const SubscribePage = lazy(() => import(/* webpackChunkName: 'Subscribe' */ './components/Buyer/Subscription/SubscribePage'));
const InitialSignUp = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/SignUp/InitialSignUp'));
const SignUp = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/SignUp/EmailConfSignUp'));
const SignUpFree = lazy(() => import(/* webpackChunkName: 'Buyer' */ './components/Buyer/SignUp/unused/CreateAccountFree'));
const SaAllProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/Direct/SaAllProducts'));
const Page404 = lazy(() => import('./components/404/404'));

const LoadingIndicator = () => (
  <div className="overlay shoplayout">
    <Hearts color="#F05F40" height={100} width={100} />
  </div>
);

const ShopLayout = ({ children }) => { 
//console.log('here!!!')
  // const { token,  buyer,  } = useLogin();
  // const { loading, fetchSubscriptionStatus  } = useSubscriptionStatus();
  // useEffect(() => {
  //   (buyer && token) && fetchSubscriptionStatus();
  // }, []);
  
  // if (loading) {
  //   return <LoadingIndicator />;
  // }

  const getLandingPage = () => {
    const seller = JSON.parse(localStorage.getItem('seller'));
    // console.log('getting landing page');
    if (seller) {
     //   console.log('sellerplace')
      if (seller.isSeller || seller.isAdmin) {
      //  conso'seller.isSeller'Seller", seller.isSeller);
        return <Navigate to="/shopper/listings" replace />;
      } else {
     //   console.log('going to sa listings')
        return <Navigate to="/sa/listings" replace />;
      }
    } else {
     // console.log('going to landing page')
    //  return  // <Navigate to="/" />;
        return <SaAllProducts />
     // return <Landing />;
    }
  }
 
  return (
    <ShopProvider>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          {/* <Route path='/' element={<SignUp />} /> */}
        
          <Route path="/" element={getLandingPage()}  />
          <Route path="/direct/*" element={<SubscriptionProtectedRoutes />} />
          {/* <Route path="/preview/*" element={<SubscriptionGuestRoutes />} /> */}
          <Route path="/confirm-order/:stoken" element={<SendConfirmation />} />
          <Route path="/bd/confirm-order/:stoken" element={<SAConfirmation />} />
          <Route path="/confirm" element={<PurchaseConfirm />} />
          <Route path="/product/:username/:_id" element={<Item />} />
          <Route path='/signup' element={<InitialSignUp />} />

          <Route path='/verify/:resettoken' element={<SignUp />} />
          <Route path='/free-verify/:resettoken' element={<SignUpFree />} />
          {/* <Route path="/" element={<Shop />} /> */}
          <Route path="/gift" element={<GiftSubscription />} />
          

          <Route path="/shop">
            <Route index element={<Shop />} />
            {/* <Route index element={<Navigate to="/" replace />} /> */}
            <Route path=":username" element={<SellerProducts />} />
            <Route path="profile/:username" element={<SellerProfile />} />
            <Route path="profile/:username/review" element={<SellerReviews />} />
            <Route path="subscribe" element={<SubscribePage />} />
          </Route>

          {/* Protected routes for Buyer */}
          <Route path="/shop/" element={<ProtectedRoute />}>
             {/* possibly move to protected section.... */}
            <Route path='customerprofile' element={(<BuyerProfile />)} />
            <Route path="notifications" element={<Notifications />} />
            
            
            {/* <Route path='history' element={<OrdersProvider><SalesTracker /></OrdersProvider>} /> */}
          </Route>

          {/* Catch-all route for 404 */}
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Suspense>
    </ShopProvider>
)};

export default ShopLayout;

     // 3 subscribe pages? 
     // /signup - initial sign up page
//   /verify/:resettoken - for new users after verifying email, subscription is chosen here.
//   /subscribe - for logged in users
//   /subscribe/complete - the return page from stripe after subscribing.
    